exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".submit-button[data-v-747cdd7f]{color:#fff;font-weight:700;font-size:16px;text-transform:none;-webkit-box-shadow:none;box-shadow:none;background-color:#00ba57;border-radius:100px;height:40px;margin-top:10px}.region-field[data-v-747cdd7f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px;padding-left:0}@media (max-width:960px){.v-flex[data-v-747cdd7f]{padding-right:0!important;padding-left:0!important}.v-layout.row[data-v-747cdd7f]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.v-flex.xs12[data-v-747cdd7f]{width:100%;max-width:100%}}h1[data-v-747cdd7f]{font-size:2rem;font-weight:700;color:#000}.v-text-field[data-v-747cdd7f]{margin-bottom:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-747cdd7f","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/b2b/CommissionTemplate.vue
// module id = h8Ij
// module chunks = 0